const PlayerSeasonStatisticsTypes = {
    GET_PLAYER_SEASON_STATISTICS_START:'GET_PLAYER_SEASON_STATISTICS_START',
    GET_PLAYER_SEASON_STATISTICS_SUCCESS:'GET_PLAYER_SEASON_STATISTICS_SUCCESS',
    GET_PLAYER_SEASON_STATISTICS_FAILED:'GET_PLAYER_SEASON_STATISTICS_FAILED',

}

export default PlayerSeasonStatisticsTypes